<template>
    <l-marker ref="markeroni"
        :options="{riseOnHover: true, riseOffset: 3000}"
        v-if="value != undefined"
        :lat-lng="value"
        @click="$emit('click', value)"
    >
        <l-icon>
            <div :class="className">
                <img width="45" height="45" style="position:absolute;z-index:0"
                    :src="value.angebote && value.angebote.some(x => x.suchStatus == 1) && value.angebote.some(x => x.suchStatus == 2) ? require('../assets/map/combinedmarker.svg') :
                        value.angebote && value.angebote.some(x => x.suchStatus == 1) || value.suchStatus == 1 ?  require('../assets/map/usermarker.svg')  :
                        require('../assets/map/carmarker.svg')"
                >
                <b-badge v-if="value && value.angebote && value.angebote.length > 1"
                    variant="primary" pill
                    style="background:#9c1ace;position:absolute;z-index:1;margin-left:3.2em;margin-top:0.05em"
                >
                    {{ badge }}
                </b-badge>
            </div>
        </l-icon>
        <uebersicht-popup-user v-if="value.resolveZoom == undefined" :value="value"/>
    </l-marker>
</template>

<script>
import { LMarker, LIcon } from 'vue2-leaflet'
import { BBadge } from 'bootstrap-vue'
import UebersichtPopupUser from "./UebersichtPopupUser"
export default {
    name: "UebersichtMarkerUser",
    components: {
        LMarker,
        LIcon,
        BBadge,
        UebersichtPopupUser
    },
    data(){
        return{
            className: 'ml-n3 mt-n2'
        }
    },
    computed:{
        badge: function(){
            return this.value && this.value.angebote ? this.value.angebote.length : 0
        }
    },
    props: {
        value: undefined
    },
    created(){
        this.className = this.className + ' usersMarker'
        setTimeout(() => this.className = 'ml-n3 mt-n2', 3000)
    }
}
</script>

<style>
.usersMarker {
    transform-origin: 1.8em;
    -webkit-animation: scaleup .3s; /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: scaleup .3s; /* Firefox < 16 */
    -ms-animation: scaleup .3s; /* Internet Explorer */
    -o-animation: scaleup .3s; /* Opera < 12.1 */
    animation: scaleup .3s;
}

@keyframes scaleup {
    0% { transform: scale(0); opacity: 0; }
    80% { transform: scale(1.1)}
}

/* Firefox < 16 */
@-moz-keyframes scaleup {
    0% { transform: scale(0); opacity: 0;  }
    80% { transform: scale(1.1)}
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes scaleup {
    0% { transform: scale(0); opacity: 0;  }
    80% { transform: scale(1.1)}
}

/* Internet Explorer */
@-ms-keyframes scaleup {
    0% { transform: scale(0); opacity: 0;  }
    80% { transform: scale(1.1)}
}

/* Opera < 12.1 */
@-o-keyframes scaleup {
    0% { transform: scale(0); opacity: 0;  }
    80% { transform: scale(1.1)}
}
</style>